export const RECTANGLE = 'Rectangle';
export const ELLIPSE = 'Ellipse';

export const DEFAULT_SHAPE_PARAMS = {
  CORNER_RADIUS: 1,
  STROKE_WIDTH: 0.2,
  STROKE_COLOR: '#000000',
  FILL_COLOR: '#000000',
};

export const DEFAULT_SHAPE_PADDING = 0.5;